export const PAY_TYPE_ALIPAY = 'AliPay';
export const PAY_TYPE_WEIXIN = 'WeiXin';
export const PAY_TYPE_CORP_WEIXIN = 'CorpWeiXin';
export const PAY_TYPE_MANUAL = 'Manual';
export const PAY_TYPE_ABC = 'ABC';
export const PAY_TYPE_CMB = 'CMB';
export const PAY_TYPE_CCBC = 'CCBC';
export const PAY_TYPE_VSP501 = 'TL-VSP501';
export const PAY_TYPE_VSP511 = 'TL-VSP511';
export const PAY_TYPE_VSP551 = 'TL-VSP551';
export const PAY_TYPE_VSP591 = 'TL-VSP591';

export const formatPayType = value => {
    switch (value) {
        case PAY_TYPE_ALIPAY:
            return '支付宝';
        case PAY_TYPE_WEIXIN:
            return '微信';
        case PAY_TYPE_CORP_WEIXIN:
            return '公司微信6101';
        case PAY_TYPE_MANUAL:
            return '手工';
        case PAY_TYPE_ABC:
            return '农行';
        case PAY_TYPE_CMB:
            return '招行';
        case PAY_TYPE_CCBC:
            return '建行';
        case PAY_TYPE_VSP501:
            return '通联微信';
        case PAY_TYPE_VSP511:
            return '通联支付宝';
        case PAY_TYPE_VSP551:
            return '通联银联';
        case PAY_TYPE_VSP591:
            return '通联云闪付';
    }
    return '';
};

export const formatCMBorCCBCPayType = value => {
    // switch (value) {
    //     case PAY_TYPE_CMB:
    //         return '招行';
    //     case PAY_TYPE_CCBC:
    //         return '建行';
    // }
    // return '';

    return [
        {value: PAY_TYPE_VSP501, key: '通联微信'},
        {value: PAY_TYPE_VSP511, key: '通联支付宝'},
        {value: PAY_TYPE_VSP551, key: '通联银联'},
        {value: PAY_TYPE_VSP591, key: '通联云闪付'},
        {value: PAY_TYPE_CMB, key: '招行'},
        {value: PAY_TYPE_CCBC, key: '建行'},

    ];
};

export const getPayTypeOptions = () => {
    return [
        {value: PAY_TYPE_VSP501, key: '通联微信'},
        {value: PAY_TYPE_VSP511, key: '通联支付宝'},
        {value: PAY_TYPE_VSP551, key: '通联银联'},
        {value: PAY_TYPE_VSP591, key: '通联云闪付'},
        {value: PAY_TYPE_ALIPAY, key: '支付宝'},
        {value: PAY_TYPE_WEIXIN, key: '微信'},
        {value: PAY_TYPE_CORP_WEIXIN, key: '公司微信6101'},
        {value: PAY_TYPE_MANUAL, key: '手工'},
        {value: PAY_TYPE_ABC, key: '农行'},
        {value: PAY_TYPE_CMB, key: '招行'},
        {value: PAY_TYPE_CCBC, key: '建行'}
    ];
};


export const getPaidText = value => {
    switch (value) {
        case 0:
            return '待支付';
        case 1:
            return '已支付';
        case 2:
            return '已关闭';
        case 3:
            return '其它';

    }
    return '';
};

export const bankRecordIsPaidList = () => {
    return [
        {value: 0, key: '待支付'},
        {value: 1, key: '已支付'},
        {value: 2, key: '已关闭'},
        {value: 3, key: '其它'}
    ];
};
